import { InteractiveBlock } from '../../../../components/interactiveBlock/InteractiveBlock'
import { InteractiveBlocks } from '../../../../components/interactiveBlock/InteractiveBlocks'
import { translations } from '../../../../configs/translations'
import { useStore } from '../../../../store/store'
import './MainChooseMap.css'

export interface MainChooseMapProps {
	runTrainingSearch: (map: string) => void
}

export const MainChooseMap = ({ runTrainingSearch }: MainChooseMapProps) => {

	const language = useStore(state => state.language) as keyof typeof translations
	const t = translations[language]


	const teleportPoints = {
		bathurst: {
			title: 'BATHURST',
			size: {
				width: 1,
				height: 1,
			},
			image: 'bathurst',
			buttons: [
				{
					text: t.start,
					action: () => runTrainingSearch('default')
				}
			]
		},
		nurburgring: {
			title: 'NURBURGRING',
			size: {
				width: 1,
				height: 2,
			},
			image: 'nurburgring',
			buttons: [
				{
					text: t.start,
					action: () => runTrainingSearch('nordschleife')
				}
			]
		},
		lemans: {
			title: 'LEMANS',
			size: {
				width: 2,
				height: 2,
			},
			image: 'lemans_big',
			buttons: [
				{
					text: t.start,
					action: () => runTrainingSearch('lemans')
				},
			]
		},
		akina: {
			title: 'AKINA',
			size: {
				width: 1,
				height: 2,
			},
			image: 'akina',
			buttons: [
				{
					text: t.start,
					action: () => runTrainingSearch('akina')
				}
			]
		},
		fujima: {
			title: 'FUJIMA',
			size: {
				width: 1,
				height: 2,
			},
			image: 'fujima',
			buttons: [
				{
					text: t.start,
					action: () => runTrainingSearch('fujima')
				}
			]
		},
		monza: {
			title: 'MONZA',
			size: {
				width: 1,
				height: 1,
			},
			image: 'monza',
			buttons: [
				{
					text: t.start,
					action: () => runTrainingSearch('monza')
				}
			]
		},
		project_touge: {
			title: 'PROJECT TOUGE',
			size: {
				width: 1,
				height: 2,
			},
			image: 'project-touge',
			buttons: [
				{
					text: t.start,
					action: () => runTrainingSearch('touge')
				}
			]
		}

	}

	return (
		<div className='main-menu-choose-map'>
			<div className='freeroam-menu'>
				<InteractiveBlock
					type='teleport'
					data={teleportPoints.nurburgring}
				/>
				<InteractiveBlock
					type='teleport'
					data={teleportPoints.lemans}
				/>
				<InteractiveBlock
					type='teleport'
					data={teleportPoints.akina}
				/>
				<InteractiveBlock
					type='teleport'
					data={teleportPoints.fujima}
				/>
				<InteractiveBlock
					type='teleport'
					data={teleportPoints.project_touge}
				/>
				<InteractiveBlocks flexDirection='column'>
					<InteractiveBlock
						type='teleport'
						data={teleportPoints.monza}
					/>
					<InteractiveBlock
						type='teleport'
						data={teleportPoints.bathurst}
					/>
				</InteractiveBlocks>
			</div>
		</div>
	)
}